import React from "react";
// react component that copies the given text inside your clipboard
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Button,    
} from "reactstrap";
import {
   Link
} from "react-router-dom";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import Select from "react-dropdown-select";
import { validEmailRegex } from '../../settings/shared/constants'
import { toast } from 'react-toastify';
import UserService from '../../services/api/User'
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Scrollbars } from 'react-custom-scrollbars';

const Provider = [
  {label: "Platform",value:'platform'},
  { label: "Google", value: "google" },
  { label: "Azure", value: 'azure' }
];

const styles = {
  errorBox:{
    textAlign:"center",
    marginBottom:20
  },
  error:{
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius:6
  },
  passwordHint:{
    color:"#000",
    fontSize:12
  }
}
class NewUser extends React.Component {

  constructor(props) {
    super(props)     
    this.state = { 
    errorSubmitted:false,
    passswordChecker:'poor',
    mode:'',
    fname:'',
    lname:'',
    email:'',
    providerType:'local',
    errorMessage:'',
    editid:'',
    lockstatus:false,
    editFlag:false,
    roleName:'',
    swidth: window.innerWidth,
    sheight: window.innerHeight,
    notificationmsg:'',
    alertFlag:false,

    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    if(localStorage.getItem("role") !== "PLATFORM_ADMIN"){
      // if the user is not a platform admin
      this.state.Roles = [
        {label: "Select Role",value:''},
        { label: "Tenant Admin", value: "TENANT_ADMIN" },
        { label: "Tenant Management", value: "TENANT_MANAGEMENT" },
        { label: "General User", value: "GENERAL_USER" },
        { label: "Developer", value: "DEVELOPER" }
      ];
    }
    else{
      // if the user is platform admin
      this.state.Roles = [
        {label: "Select Role",value:''},
        {label:"Platform Admin",value:"PLATFORM_ADMIN"},
        { label: "Tenant Admin", value: "TENANT_ADMIN" },
        { label: "Tenant Management", value: "TENANT_MANAGEMENT" },
        { label: "General User", value: "GENERAL_USER" },
        { label: "Developer", value: "DEVELOPER" }
      ];
    }
}


 componentDidMount() {
  this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);

       let mode = this.props.location.state.mode;
      mode === "edit"?
      this.setState({
        editFlag:true,
        editid:this.props.location.state.EditData.id,
        fname:this.props.location.state.EditData.firstName,
        lname:this.props.location.state.EditData.lastName,
        email:this.props.location.state.EditData.email,
        roleName:this.props.location.state.EditData.role,
        providerType:this.props.location.state.EditData.authProvider === "local"?'':this.props.location.state.EditData.authProvider,
        lockstatus:this.props.location.state.EditData.status
      })
      :
      this.setState({
        editFlag:false,
      })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }
  setErrorMessage(message){
     if(message === ""){
       this.setState({
         errorMessage:message,
         errorSubmitted:false
       })
     }else{
    document.getElementById('errorDiv').scrollIntoView()
     this.setState({
       errorMessage:message,
       errorSubmitted:true
     });
     }
  }

  handleChangeSelect = (event) => {
    this.setState({
      roleName:event[0].value
    });
  }

    handleChangeSelect_provider = (event) => {
    this.setState({
      providerType:event[0].value
    });
  }

  handleChange = (event) => {
    event.preventDefault();
    this.setState({alertFlag:false})
    const { name, value } = event.target;
      this.setState({ [name]: value});
  }

  // Submit user Data
  CreateAccount = (event) => {
    event.preventDefault();
    if((this.state.fname === "" || this.state.fname === undefined)){
        this.setErrorMessage("Please Enter First Name");
      }
      else if((this.state.fname.length < 3)){
        this.setErrorMessage("First Name must be 3 characters long!");
      }
      else if(this.state.email === "" || this.state.email === undefined){
         this.setErrorMessage("Please Enter Email Id");
      }
      else if(!validEmailRegex.test(this.state.email)){
            this.setErrorMessage("Email is not valid!");
      }
      else if(this.state.roleName === ""){
          this.setErrorMessage("Please Select a Role");

      }
       else{
        this.setState({alertFlag:false})
         this.setErrorMessage("");
          if(!this.state.errorSubmitted) {     
                let post ={
                firstName:this.state.fname,
                lastName:this.state.lname,
                email:this.state.email,
                role:this.state.roleName,
                authProvider:this.state.providerType === ""?"local":this.state.providerType,
                organisation:localStorage.getItem("accountId")
              }
                //Post new user service integration
                UserService.PostNewUser(post)
                .then((response) => {
                    if (response.status === 'SUCCESS') {
                    toast.success(<i className="fas fa-check-circle">&nbsp;<b className="toast-txt">User Created Successfully!</b></i>); 
                    this.setState({alertFlag:true,notificationmsg:"User Created Successfully!"})
                    this.props.history.push('/admin/usermanagement');    
                    this.clearformData();   // Reset Form data    
                    } else {
                      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
                    this.setState({alertFlag:true,notificationmsg:response.errorMessage})
                    this.clearformData();   // Reset Form data    
                    }
                });
                  }else{
                    console.error('Invalid Form')
                  }
      }  
  }

  // Delete particular user
   DeleceAccount = () =>{
     confirmAlert({
      title: 'Delete User',
      message: 'Are you sure to delete this user?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.confirmDelete()
        },
        {
          label: 'No',
          onClick: () =>{
          } 
        }
      ]
    });
   }

   LockUnlockUser = () => {
     if(this.state.lockstatus === true){
       UserService.DeActivateUser(this.state.editid)
        .then((response) => {
          this.props.history.push('/admin/usermanagement');
        });
     }else{
       UserService.ActivateUser(this.state.editid)
        .then((response) => {
          this.props.history.push('/admin/usermanagement');
        });
     }
   }

   confirmDelete(){
       UserService.DeleteUser(this.state.editid)
        .then((response) => {
            if (response.status === 'SUCCESS') {
             toast.success(<i className="fas fa-check-circle">&nbsp;<b className="toast-txt">User Deleted Successfully!</b></i>); 
            this.props.history.push('/admin/usermanagement');    
            } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 

            }
        });
   }

  // Update user Data
  UpdateAccount = () => {
    if((this.state.fname === "" || this.state.fname === undefined)){
        this.setErrorMessage("Please Enter First Name");
      }
      else if((this.state.fname.length < 3)){
        this.setErrorMessage("First Name must be 3 characters long!");
      }
      else if(this.state.roleName === ""){
          this.setErrorMessage("Please Select a Role");
      }
       else{
         this.setErrorMessage("");
          if(!this.state.errorSubmitted) {     
                let put ={
                firstName:this.state.fname,
                lastName:this.state.lname,
                email:this.state.email,
                role:this.state.roleName,
                authProvider:this.state.providerType === ""?"local":this.state.providerType,
                organisation:localStorage.getItem("accountId")
              }
                //Post new user service integration
                UserService.UpdateUser(put,this.state.editid)
                .then((response) => {
                    if (response.status === 'SUCCESS') {
                    toast.success(<i className="fas fa-check-circle">&nbsp;<b className="toast-txt">User Updated Successfully!</b></i>); 
                    this.props.history.push('/admin/usermanagement');    
                    } else {
                    toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 

                    }
                });
                  }else{
                    console.error('Invalid Form')
                  }
      }   
  }


  // Reset form data
  clearformData(){
    this.setState({
      fname:"",
      lname:"",
      email:'',
      roleName:''
    })
  }


  render() {
    return (
   
      <>
      <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
        <div className="content">
        <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
        <Col xs={12} md={12}>
          <Row>
            <div className=" col" id="errorDiv">
              <Card>
                <CardHeader className=" bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      {!this.state.editFlag && <h5 className="mb-0">New User</h5>}
                      {this.state.editFlag && <h5 className="mb-0">Edit User</h5>}
                    </div>
                    <div className="col text-right">
                    <Link to="usermanagement" > 
                    <span className="close clear-filter">×</span>                     
                      </Link>
                     
                    </div>
                  </Row>
               </CardHeader>
                <CardBody>
                <div className="carcontent">
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-200}>

                    {this.state.errorSubmitted &&
                    <div style={styles.errorBox}>
                    <span style={styles.error}>{this.state.errorMessage}</span>
                    </div>
                    }
                  <Form onSubmit={this.CreateAccount} noValidate>
                    <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                             First Name
                            </label>
                            <Input
                          className="form-control"
                          placeholder="First Name"
                          name="fname"
                          value={this.state.fname}
                          type="text"
                          onChange={this.handleChange}/>
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                             Last Name
                            </label>
                            <Input
                          className="form-control"
                          placeholder="Last Name"
                          name="lname"
                          value={this.state.lname}
                          type="text"
                          onChange={this.handleChange}/>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                          <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                             Email
                            </label>
                            <Input
                          className="form-control"
                          placeholder="Email"
                          name="email"
                          value={this.state.email}
                          type="text"
                          disabled={this.state.editFlag}
                          onChange={this.handleChange}/>
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>  
                              <label
                                className="form-control-label"
                                htmlFor="input-username"
                              >
                                Select a Role
                              </label>
                              <Select className="form-control" name="roleName"  options={this.state.Roles} 
                              values={this.state.Roles.filter(item=>item.value === this.state.roleName)}
                              onChange={this.handleChangeSelect} noValidate/>
                            </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                          <Col lg="6">
                          <FormGroup>  
                              <label
                                className="form-control-label"
                                htmlFor="input-username"
                              >
                                Provider
                              </label>
                              <Select className="form-control" name="roleName"  options={Provider} 
                              values={Provider.filter(item=>item.value === this.state.providerType)}
                              onChange={this.handleChangeSelect_provider} noValidate/>
                            </FormGroup>
                        </Col>
                        <Col lg="6">
                   
                        </Col>
                      </Row>
                  
                    </div>
                    <hr className="my-4" />
                    {!this.state.editFlag && <Row className="stickybuttons">  
                    <Col lg="2">
                    <FormGroup>
                     <Button
                       color="primary"
                       size="sm"
                       type="submit"
                     >
                       Create User
                     </Button>
                     </FormGroup>
                     </Col>
                     </Row>}

                     {this.state.editFlag && <Row>  
                       <Col lg="1">
                       
                       <FormGroup>
                       <br></br>
                         <br></br>
                     <Button
                       color="primary"
                       size="sm"
                       onClick={e=>this.UpdateAccount()}
                     >
                       Update
                     </Button>
                     </FormGroup>
                     </Col>
                     <Col lg="1">
                       
                       <FormGroup>
                       <br></br>
                         <br></br>
                     <Button
                       color="primary"
                       onClick={e => this.DeleceAccount()}
                       size="sm"
                     >
                      Delete
                     </Button>
                     </FormGroup>
                     </Col>
                     <Col lg="2">
                       <FormGroup>
                       <br></br>
                       <br></br>
                     {this.state.editFlag && <Button
                       color="primary"
                       onClick={e => this.LockUnlockUser()}
                       size="sm"
                     >
                      {this.state.lockstatus?"Temporary Lock":"Unlock"}
                     </Button>}
                     </FormGroup>
                     </Col>
                    </Row>}
                    </Form>
                    </Scrollbars>

                    </div>
                </CardBody>
              </Card>
            </div>
          </Row>
        </Col>
        </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default NewUser;
